
export const workflowEndpoints = {

    getAllWorkflow: '/api/Workflow/Filter',
    deleteWorkflow: '/api/Workflow/Delete',
    createWorkflow: '/api/Workflow/Insert',

    getWorkflowProcessList: '/api/WorkflowProcess/Filter',
    createWorkFlowInstance: '/api/WorkflowProcess/Insert',

    deleteWorkflowProcessInstance: '/api/WorkflowProcess/Delete',
    addWorkflowDocument: '/api/WorkflowProcess/AddDocument',
    approveAction: '/api/WorkflowProcess/ApproveAction',
    approveItem: '/api/WorkflowProcess/ApproveItem'
};